import React from 'react';
import EditIcon from "@as_core/icons/edit.icon";
import MenuButton from "@as_core/elements/MenuButton";
import { Row, Column } from '../common/flexStyles';
import RequestDetailsTile from '../common/RequestDetailsTile';
import RequestProcessDetails from '../common/RequestProcessDetails';
import AssayRequestForms from '../assay/AssayRequestForms';
import ConsultingRequestForms from '../consulting/ConsultingRequestForms';
import AssayDataForms from './AssayDataForms';
import useRequests, {canPartnerUpdateRequest, RequestT, RequestUpdateT} from '../hooks/useRequests';
import {UserEmailDictionaryT} from '../hooks/useUserEmails';
import useRequestStatus from '../hooks/useRequestStatus';
import {useQuery} from "@tanstack/react-query";
import BackArrowIcon from "@components/icons/backArrow.icon";

interface PropsI {
  request: RequestT;
  userEmails: UserEmailDictionaryT;
  handleRequestUpdate: (id: number, updates: RequestUpdateT) => Promise<void>;
  handleEdit: () => void;
  handleBack?: () => void;
}

const debug = false;
const RequestDetails = (props: PropsI) => {
  const {request, userEmails, handleRequestUpdate, handleEdit} = props;
  const allowEdit = canPartnerUpdateRequest(request?.status);
  const { getRequestType } = useRequests();
  const { getRequestStatus } = useRequestStatus();
  const requestType = getRequestType(request).category;
  if (debug) console.log('partners/RequestDetails | props:', props);

  // load the current status
  let { isError, error, data: status } = useQuery({
    queryKey: ['requestStatus', request.id],
    queryFn: () => getRequestStatus(request),
  })
  if (isError) console.error(error.message);

  if (debug) console.log('partners/RequestDetails | {request.id, requestType, status}:',
      request.id, requestType, status);

  return (
    <>
      <Row v_align={'flex-start'}>
        <Column width={'440px'}>
          <Row>
            { props?.handleBack && (
              <MenuButton
                onClick={() => props.handleBack()}
                icon={<BackArrowIcon/>}
                text={'Back to List'}
                tooltipPlacement={'bottom'}
              />
            )}
            { allowEdit && (
              <MenuButton
                onClick={() => handleEdit()}
                icon={<EditIcon/>}
                text={'Update Request'}
                tooltipPlacement={'bottom'}
              />
            )}
          </Row>
          <RequestDetailsTile
            viewMode={'partners'}
            request={request}
            userEmails={userEmails}
          />
          { requestType === 'subscription' ?
            <></>
            : requestType === 'consulting' ?
            <ConsultingRequestForms
              viewMode='partners'
              request={request}
              status={status}
              updateSelectedRequest={handleRequestUpdate}
            />
            :
            <>
              <AssayRequestForms
                viewMode='partners'
                request={request}
                status={status}
                updateSelectedRequest={handleRequestUpdate}
              />
              <AssayDataForms
                viewMode='partners'
                request={request}
              />
            </>
          }
        </Column>
        { requestType === 'subscription' ? <></>
        :
        <Column width={'720px'}>
          <RequestProcessDetails
          view={'partners'}
          request={request}
          />
        </Column>
        }
      </Row>
    </>
  );
};

export default RequestDetails;
